<script setup>
import IconBack from '~icons/material-symbols/arrow-back-ios-new'
import IconNext from '~icons/material-symbols/arrow-forward-ios'

const props = defineProps({
  page: Number,
  hasNextPagination: Boolean,
})

const emit = defineEmits(['changePage'])
const { t } = useI18n()

function previousPage() {
  if (props.page > 1)
    emit('changePage', props.page - 1)
}

function nextPage() {
  if (props.hasNextPagination)
    emit('changePage', props.page + 1)
}
</script>

<template>
  <div class="flex justify-center items-center mt-4 gap-3">
    <SolButton
      id="btn-previous-bank-statement"
      size="small"
      variant="tertiary"
      :disabled="page === 1"
      @click="previousPage()"
    >
      <template #icon-left>
        <IconBack class="w-2 mr-1" />
      </template>
      {{ t('app.previous') }}
    </SolButton>

    <SolButton
      id="btn-next-bank-statement"
      size="small"
      variant="tertiary"
      :disabled="!hasNextPagination"
      @click="nextPage()"
    >
      <template #icon-right>
        <IconNext class="w-2 ml-1" />
      </template>
      {{ t('app.next') }}
    </SolButton>
  </div>
</template>
